import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="column tcolumn-1">
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>{this.state.errorInfo && this.state.errorInfo.componentStack.toString()}</details>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
